import { render, staticRenderFns } from "./stringArrayEditor.vue?vue&type=template&id=13a069da&scoped=true&"
import script from "./stringArrayEditor.vue?vue&type=script&lang=js&"
export * from "./stringArrayEditor.vue?vue&type=script&lang=js&"
import style0 from "./stringArrayEditor.vue?vue&type=style&index=0&id=13a069da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a069da",
  null
  
)

export default component.exports